import "./Background.scss";

import Background from "./Background";

export default Background;
